import { useContext } from 'react';
import { BoostSubscriptionContext } from '../context/boost-subscription-context';

export const useBoostSubscriptionContext = () => {
    return useContext(BoostSubscriptionContext);
};
